import { useMediaQuery } from '@chakra-ui/react';

export function useDeviceWidth() {
  const MIN_WIDTH = '600px';
  const [isMobileView] = useMediaQuery(`(max-width: ${MIN_WIDTH})`);
  const [isDesktopView] = useMediaQuery(`(min-width: ${MIN_WIDTH})`);

  return {
    isMobileView,
    isDesktopView,
  };
}
